/**
 * Meu perfil -- a tela inicial do accounts.
 *
 * **Nao declara `permissao`, de proposito.** Toda pessoa autenticada tem uma
 * conta para cuidar, entao exigir permissao aqui trancaria o item de menu
 * para quem nao esta em grupo nenhum -- que e exatamente quem mais precisa
 * chegar nela (para ligar o segundo fator, trocar a senha, derrubar uma
 * sessao). `pode()` trata `permissao` ausente como "sempre libera".
 *
 * `section` e a mesma "Resources" dos outros modulos -- o `LeftSidebar` so
 * sabe renderizar essa unica pasta hoje, um item de menu fora dela nao
 * apareceria (o template so olha `section.menu`, nunca a raiz). `sequence`
 * negativo e o que garante o primeiro lugar dentro dela.
 */
export const nav = {
    section: 'Resources',
    title: 'MyProfile',
    icon: 'account_circle',
    route: '/perfil',
    accordion: false,
    sequence: -1,
};

export default [
    {
        path: '/perfil',
        name: 'perfil',
        component: () => import('./pages/PerfilPage.vue'),
        meta: { requiresAuth: true },
    },
];
